'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { textLightColor, textDarkColor } from "../color.css.js";
const getOnActionColor = (backgroundColor) => tinycolor.mostReadable(backgroundColor, [textLightColor, textDarkColor]).toHexString();
export {
  getOnActionColor
};
